import { linkToString as centralLinkToString } from '@/helper/urls';
import type { MultilinkStoryblok } from '@/storyblok/wirfuersklima/types';

export function linkToString(link: MultilinkStoryblok | undefined): string {
  if (!link || typeof link !== 'object') {
    return '#';
  }

  const resolved = centralLinkToString(link as Parameters<typeof centralLinkToString>[0]);
  return resolved || '#';
}
